import { LandingNavbar } from "../components/Homepage/landing-navbar"
import Documents from "../components/Documents"

const DocumentsPage = () => {
    return (
    <main className="h-full bg-[#111827] overflow-auto">
        <div className="mx-auto max-w-screen-xl h-full w-full">
            <LandingNavbar />
            <Documents />
        </div>
      </main>
    )
}

export default DocumentsPage